module.exports = __webpack_public_path__ + "img/98b0332.png";